export const DEFAULT_CUSTOM_STYLES = {
  grid: {
    textColor: '[#23282E]',
    textColorDark: '[#F7F7F7]',
  },
};
